import { render, staticRenderFns } from "./Currency.vue?vue&type=template&id=6728008e"
import script from "./Currency.vue?vue&type=script&lang=js"
export * from "./Currency.vue?vue&type=script&lang=js"
import style0 from "./Currency.vue?vue&type=style&index=0&id=6728008e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports